import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const API_URL = '';

export default function ConsultationPage() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: '', mobile: '', email: '', topic: '', preferred_time: '' });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || form.mobile.trim().length !== 10) {
      setError('कृपया नाम और 10 अंकों का mobile नंबर भरें');
      return;
    }
    setSubmitting(true);
    setError('');
    try {
      const res = await fetch(`${API_URL}/api/consultation-book`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      });
      const data = await res.json();
      if (data.success && data.payment_url) {
        navigate(data.payment_url);
        return;
      }
      setError('कुछ गलत हुआ। कृपया पुनः प्रयास करें।');
    } catch (err) {
      setError('कुछ गलत हुआ। कृपया पुनः प्रयास करें।');
    }
    setSubmitting(false);
  };

  const inputCls = "w-full px-4 py-3 rounded-xl bg-[#17171C] border border-[#d4a84b]/40 text-[#F3EDE2] placeholder-[#8a8578] focus:outline-none focus:border-[#E2C170] text-base";

  return (
    <div className="min-h-screen bg-[#0B0B0E] py-10 px-4" data-testid="consultation-page">
      <div className="max-w-xl mx-auto">
        {/* Offer Hero */}
        <div className="text-center mb-8">
          <img src="/mata-profile.jpg" alt="माता मलिहा जी" className="w-24 h-24 rounded-full border-4 border-[#C9A23A] mx-auto mb-4 shadow-lg" />
          <h1 className="text-3xl sm:text-4xl font-black text-[#E2C170] mb-2" style={{ fontFamily: "'Rozha One', serif" }}>
            माता मलिहा जी से सीधे बात करें
          </h1>
          <p className="text-[#D8D2C6] text-lg">30 मिनट व्यक्तिगत Consultation Call</p>
        </div>

        {/* Offer Box */}
        <div className="p-5 rounded-2xl bg-gradient-to-br from-[#250808] to-[#17070a] border border-[#C9A23A]/50 text-center mb-6" data-testid="consult-offer-box">
          <p className="text-[#D8D2C6] text-sm mb-1">परामर्श शुल्क (30 मिनट)</p>
          <p className="text-[#8a8578] text-2xl font-bold line-through">₹5500</p>
          <p className="text-[#E2C170] text-4xl font-black my-1">केवल ₹2100</p>
          <p className="text-[#F3EDE2] text-sm mt-2">🎁 विशेष कृपा छूट — सीमित समय के लिए</p>
        </div>

        {/* What you get */}
        <div className="p-4 rounded-xl bg-[#17171C] border border-[#d4a84b]/30 mb-6">
          <p className="text-[#E2C170] font-bold mb-2">📞 Consultation में क्या मिलेगा:</p>
          <ul className="text-[#F3EDE2] text-sm space-y-1.5">
            <li>✓ माता जी से सीधी फोन पर बात — पूरे 30 मिनट</li>
            <li>✓ समस्या की असली जड़ का दिव्य दर्शन</li>
            <li>✓ तुरंत करने योग्य उपाय और मार्गदर्शन</li>
            <li>✓ पूरी गोपनीयता — बात सिर्फ आपके और माता जी के बीच</li>
          </ul>
        </div>

        {/* Booking Form */}
        <form onSubmit={handleSubmit} className="p-6 rounded-2xl bg-gradient-to-br from-[#17171C] to-[#101014] border border-[#d4a84b]/60 space-y-4" data-testid="consultation-form">
          <div>
            <label className="block text-[#E2C170] font-bold text-sm mb-1.5">आपका नाम *</label>
            <input name="name" value={form.name} onChange={handleChange} required placeholder="पूरा नाम" className={inputCls} data-testid="consult-name-input" />
          </div>
          <div>
            <label className="block text-[#E2C170] font-bold text-sm mb-1.5">Mobile नंबर * (इसी पर call आएगी)</label>
            <input name="mobile" value={form.mobile} onChange={handleChange} required maxLength={10} placeholder="10 अंकों का नंबर" className={inputCls} data-testid="consult-mobile-input" />
          </div>
          <div>
            <label className="block text-[#E2C170] font-bold text-sm mb-1.5">Email</label>
            <input name="email" type="email" value={form.email} onChange={handleChange} placeholder="example@gmail.com" className={inputCls} data-testid="consult-email-input" />
          </div>
          <div>
            <label className="block text-[#E2C170] font-bold text-sm mb-1.5">किस विषय पर बात करनी है?</label>
            <textarea name="topic" value={form.topic} onChange={handleChange} rows={3} placeholder="अपनी समस्या/प्रश्न संक्षेप में लिखें" className={inputCls} data-testid="consult-topic-input" />
          </div>
          <div>
            <label className="block text-[#E2C170] font-bold text-sm mb-1.5">पसंदीदा समय</label>
            <select name="preferred_time" value={form.preferred_time} onChange={handleChange} className={inputCls} data-testid="consult-time-select">
              <option value="">कोई भी समय</option>
              <option value="सुबह (9-12)">सुबह (9-12)</option>
              <option value="दोपहर (12-4)">दोपहर (12-4)</option>
              <option value="शाम (4-8)">शाम (4-8)</option>
              <option value="रात्रि (8-10)">रात्रि (8-10)</option>
            </select>
          </div>
          {error && <p className="text-red-400 text-sm font-bold" data-testid="consult-error">{error}</p>}
          <button type="submit" disabled={submitting} data-testid="consult-submit-btn"
            className="w-full py-4 rounded-xl font-black text-lg text-[#1a0505] bg-gradient-to-r from-[#E2C170] to-[#C9A23A] hover:opacity-90 disabled:opacity-50 transition-opacity">
            {submitting ? '⏳ प्रतीक्षा करें...' : '📞 Consultation Book करें — ₹2100'}
          </button>
          <p className="text-[#8a8578] text-xs text-center">Book करते ही payment page खुलेगा। Payment के बाद 24 घंटे में सेवा दल call का समय confirm करेगा।</p>
        </form>

        <p className="text-center text-[#F3EDE2] text-sm mt-6">❖ जय माता मलिहा ❖</p>
      </div>
    </div>
  );
}
